import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
  selector: 'app-kendo-textbox',
  templateUrl: './kendo-textbox.component.html',
  styleUrls: ['./kendo-textbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KendoTextboxComponent),
      multi: true,
    },
  ],
})
export class KendoTextboxComponent implements ControlValueAccessor {
  @Input() inputText: string; // input text value
  @Input() formControlName: string; // represents form control name
  @Input() inputType: string; // represents type of control
  @Input() parentForm: FormGroup; // represents form
  @Input() autofillValue: string; // represents autofill values
  @Input() maxLength = 50;
  @ViewChild('textbox') textbox: TextBoxComponent;
  @Output() outputParameter: EventEmitter<any> = new EventEmitter<any>();
  value: string;

  onChange = (value: string) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  typing() {
    this.outputParameter.emit();
  }

  focus() {
    this.textbox.focus();
  }
}
